export default function safeJsonStringify(value: unknown, indent?: number): string {
  try {
    return JSON.stringify(value, null, indent) ?? ''
  } catch {
    return '[Unserializable]'
  }
}
